function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import tasks from '@/js/tasks';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var appApisGTW = null;
if (!configuration['work_env']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8000')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8091')
  });
}
setupInterceptors(appApisGTW);
var CONTROLLER_NAME = '/work_environments';
var DOMAIN_RESOURCES = '/resources';
var DOMAIN_REQUEST = '/request';
var DOMAIN_CONFIG = '/config';
var DOMAIN_MONITORING = '/monitoring';
var headers = {
  headers: {
    'Content-Type': 'application/json'
  }
};
export default {
  getResources: function getResources() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var params = _objectSpread({}, data);
    tasks.lockScreen.lock();
    return appApisGTW.get("".concat(CONTROLLER_NAME).concat(DOMAIN_RESOURCES, "/list"), {
      params: params
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  toggleResource: function toggleResource() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var body = _objectSpread({}, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_RESOURCES, "/toggle"), body, headers).then(function (response) {
      return response.data;
    });
  },
  getConfig: function getConfig() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var params = _objectSpread({}, data);
    return appApisGTW.get("".concat(CONTROLLER_NAME).concat(DOMAIN_CONFIG, "/init"), {
      params: params
    }).then(function (response) {
      return response.data;
    }).catch(function (error) {
      console.error(error);
    });
  },
  getProjectsGcp: function getProjectsGcp() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var params = _objectSpread({}, data);
    return appApisGTW.get("".concat(CONTROLLER_NAME).concat(DOMAIN_CONFIG, "/projects_gcp"), {
      params: params
    }).then(function (response) {
      return response.data;
    }).catch(function (error) {
      console.error(error);
    });
  },
  getResourcesRequests: function getResourcesRequests() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var params = _objectSpread({}, data);
    tasks.lockScreen.lock();
    return appApisGTW.get("".concat(CONTROLLER_NAME).concat(DOMAIN_REQUEST, "/list"), {
      params: params
    }, headers).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  requestResource: function requestResource() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var body = _objectSpread({}, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_REQUEST), body, headers).then(function (response) {
      return response.data;
    });
  },
  updateResource: function updateResource() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var body = _objectSpread({}, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_REQUEST, "/update"), body, headers).then(function (response) {
      return response.data;
    });
  },
  approveResource: function approveResource() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var body = _objectSpread({}, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_REQUEST, "/approve"), body, headers).then(function (response) {
      return response.data;
    });
  },
  approveUpdateResource: function approveUpdateResource() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var body = _objectSpread({}, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_REQUEST, "/approve_update"), body, headers).then(function (response) {
      return response.data;
    });
  },
  rejectResource: function rejectResource() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var body = _objectSpread({}, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_REQUEST, "/reject"), body, headers).then(function (response) {
      return response.data;
    });
  },
  monitoringGraphics: function monitoringGraphics() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var body = _objectSpread({}, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_MONITORING, "/graphics"), body, headers).then(function (response) {
      return response.data;
    });
  }
};